export default "__VITE_ASSET__O_1$uiOs__"